/* eslint-disable no-useless-constructor */
import Model from '@/models/Model'
import News from '@/models/catalog/News';
import Article from '@/models/catalog/Article';
import Page from '@/models/catalog/Page';
import Perfume from '@/models/catalog/perfume';

export default class Segment extends Model {
    resource() {
        return 'years'
    }

    primaryKey() {
        return 'code'
    }

    perfumes() {
        return this.hasMany(Perfume, 'perfumes')
    }

    relatedNews() {
        return this.hasMany(News, 'related-news')
    }

    relatedArticles() {
        return this.hasMany(Article, 'related-articles')
    }

    relatedPages() {
        return this.hasMany(Page, 'related-pages')
    }
}
